import { render } from "./Corp.vue?vue&type=template&id=588c5abc&scoped=true"
import script from "./Corp.vue?vue&type=script&lang=js"
export * from "./Corp.vue?vue&type=script&lang=js"

import "./Corp.vue?vue&type=style&index=0&id=588c5abc&scoped=true&lang=css"

import exportComponent from "/home/jenkinsx/workspace/build-dc-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588c5abc"]])

export default __exports__